import ExitEditLayoutButton from "app/WebController/TitleBar/Button/ExitEditLayoutButton"
import ForceGridBreakpointButton from "app/WebController/TitleBar/Button/ForceGridBreakpointButton"
import ModuleLayoutSelector from "app/WebController/TitleBar/Button/ModuleLayoutSelector"
import ShowSettingsButton from "app/WebController/TitleBar/Button/ShowSettingsButton"
import React from "react"

interface ModuleHeadingViewProps {
  title: string | undefined
  isEditLayout: boolean
}

function TitleBarView({title, isEditLayout}: ModuleHeadingViewProps) {
  const moduleHeading = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }

  const ButtonWrapperStyle = {
    display: 'flex',
    alignSelf: 'stretch',
  }

  return (
    <div style={moduleHeading} className={`title-bar`} id={'title-bar'}>
      <h1>{title}</h1>
      <div style={ButtonWrapperStyle} className={'buttons'}>
        {!isEditLayout && (
          <>
            <ModuleLayoutSelector/>
            <ShowSettingsButton/>
          </>
        )}
        {isEditLayout && (
          <>
            <ForceGridBreakpointButton/>
            <ExitEditLayoutButton/>
          </>
        )}
      </div>
    </div>
  )
}

export default TitleBarView
